<template>
  <div class="row">
    <div class="col-sm-6">
      <card class="stacked-form">
        <form @submit.prevent="submit">
          <fg-input label="Bestellungen Absender E-Mail Adresse"
            type="email"
            v-model="orderEmail"
          />
          <button type="submit" class="btn btn-fill btn-info">Speichern</button>
        </form>
      </card>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      orderEmail: ''
    }
  },
  methods: {
    async submit () {
      await this.initCsrf()

      this.$http.put('/settings', {
        order_email: this.orderEmail
      }).then(() => {
        this.$notify({
          message: 'Allgemeine Einstellungen erfolgreich gespeichert.',
          type: 'success'
        })
      })
    }
  },
  created () {
    this.$http.get('/settings').then(({ data }) => {
      this.orderEmail = data.order_email
    })
  }
}
</script>

<style>
</style>
